export const generateSlug = (name) => {
  return name
    .normalize("NFD") // remove acentos
    .replace(/[\u0300-\u036f]/g, "") // remove os caracteres dos acentos
    .toLowerCase()
    .replace(/\s+/g, "-") // substitui espaços por hífen
    .replace(/[^a-z0-9-]/g, ""); // remove caracteres especiais
};
